export const modalOverlayVariants = {
	hidden: {
		opacity: 0,
		transition: {
			duration: 0.25,
		},
	},
	visible: {
		opacity: 1,
		transition: {
			duration: 0.25,
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.25,
		},
	},
};